import { render, staticRenderFns } from "./BenefitRemark.vue?vue&type=template&id=f9fa1f40"
import script from "./BenefitRemark.vue?vue&type=script&lang=js"
export * from "./BenefitRemark.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports